import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';

export const SingleREFilter = ({
  setMainFilters,
  mainFilters,
  options,
  isDisabled
}) => {
  const handleChange = selectedOption => {
    setMainFilters(state => ({
      ...state,
      realEstateId: Number(selectedOption.value)
    }));
  };

  const selectOptions = options.map(estate => ({
    value: estate.id,
    label: estate.name
  }));

  return (
    <Form.Group>
      <Select
        options={selectOptions}
        value={selectOptions.find(
          option => option.value === mainFilters.realEstateId
        )}
        onChange={handleChange}
        isDisabled={isDisabled}
      />
    </Form.Group>
  );
};

SingleREFilter.propTypes = {
  setMainFilters: PropTypes.func.isRequired,
  mainFilters: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool
};
